import React from 'react';
import cx from 'classnames';
import Button, { Color, Size } from 'lib/Button';
import graphBarChartSVG from 'assets/icons/graph-bar-chart.svg';
import usePendoTracking from 'customHooks/usePendoTracking';
import { ReportTypeButtonsProps } from './ReportTypeButtons.types';

export const ReportTypeButtons: React.FC<ReportTypeButtonsProps> = ({ reportTypeButtons }) => {
  const { getPendoDataId } = usePendoTracking();
  const visibleReportTypeButtons = reportTypeButtons.filter(({ isVisible }) => isVisible);

  if (visibleReportTypeButtons.length === 0) return null;

  return (
    <div className="flex gap-2">
      {visibleReportTypeButtons.map(({ id, isActive, isOnClickEnabled, label, onClick }) => (
        <React.Fragment key={id}>
          <Button
            onClick={isOnClickEnabled ? onClick : undefined}
            color={isActive ? Color.TERTIARY : Color.TRANSPARENT}
            size={Size.SMALL}
            label={label}
            classNames={cx('border', {
              'border-primary-600': isActive,
              'cursor-default': !isOnClickEnabled,
            })}
            ddActionName={`Allocation report / ${label} chip`}
            dataPendoId={getPendoDataId(`Allocation report / ${label} chip`)}
            svg={graphBarChartSVG}
          />
        </React.Fragment>
      ))}
    </div>
  );
};
